import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography
} from '@material-ui/core'
import React from 'react'

export const ANSWERS = [
  { value: 'yes', label: 'Yes', color: '#2d9d63' },
  { value: 'no', label: 'No', color: '#b3261e' },
  { value: 'not_sure', label: 'Not sure', color: '#9a8f82' }
]

// The questions, section by section: on the new-audit page and the edit pop-up.
export const AuditQuestions = ({
  sections,
  answers,
  comments,
  sectionComments,
  onAnswer,
  onSectionComment
}) =>
  sections.map((s) => (
    <Box key={s.key} mt={1}>
      <Typography variant="subtitle2" gutterBottom>
        {s.title}
      </Typography>
      {s.questions.map((q) => (
        <Box
          key={q.key}
          display="flex"
          flexWrap="wrap"
          alignItems="center"
          justifyContent="space-between"
          style={{ gap: 12 }}
        >
          <Typography variant="body2" style={{ flex: '1 1 240px' }}>
            {q.title}
          </Typography>
          <RadioGroup
            row
            value={answers?.[q.key] || ''}
            onChange={onAnswer(q.key)}
            style={{ flexShrink: 0 }}
          >
            {ANSWERS.map((a) => (
              <FormControlLabel
                key={a.value}
                value={a.value}
                label={a.label}
                control={<Radio size="small" color="primary" />}
              />
            ))}
          </RadioGroup>
        </Box>
      ))}
      {sectionComments && (
        <TextField
          label="Comment"
          fullWidth
          multiline
          minRows={2}
          value={comments?.[s.key] || ''}
          onChange={onSectionComment(s.key)}
        />
      )}
    </Box>
  ))
